import { useState, useCallback } from 'react';

export type View = 'loading' | 'lobby' | 'game' | 'expired' | 'error';

export function useView(initial: View = 'loading') {
  const [view, setView] = useState<View>(initial);
  return {
    view,
    goLoading: useCallback(() => setView('loading'), []),
    goLobby: useCallback(() => setView('lobby'), []),
    goGame: useCallback(() => setView('game'), []),
    goExpired: useCallback(() => setView('expired'), []),
    goError: useCallback(() => setView('error'), []),
  };
}
